import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.label,
      "item": item.href ? `https://www.90yingshi.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-1.5 text-xs md:text-sm text-foreground-500 flex-wrap">
          {items.map((item, idx) => (
            <span key={idx} className="flex items-center gap-1.5">
              {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
              )}
            </span>
          ))}
        </div>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}